import { Box, Button, createTheme, Dialog, MenuItem, Select, TextField, ThemeProvider, Paper } from '@mui/material';
import { FilteringState, IntegratedFiltering, } from '@devexpress/dx-react-grid';
import { Grid, Table, TableFilterRow, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { IntegratedSorting, SortingState } from '@devexpress/dx-react-grid';

import { Typography, withStyles } from '@material-ui/core';

import { withRouter } from 'react-router-dom';

import React, { useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  }
});

const ChangeFeeStatusDialog = props => {
  const { open, onSave, onCancel, feeStatusReasons, selectedRows, columns, feeStatuses, sorting, filters, integratedFilteringColumnExtensions, tableColumnExtensions, classes,
    rowComponent, tableComponent, cellComponent, noDataCellComponent, headerRowComponent, headerCell, filterCell, changeSorting, changeFilters
   } = props;

  const theme = createTheme({
    palette: {
        primary: COLOR_PRIMARY,
        secondary: COLOR_SECONDARY,
        warning: COLOR_WARNING
    }
  });

  const [updateStatusId, setUpdateStatusId] = useState('');
  const [updateStatusReasonId, setUpdateStatusReasonId] = useState('');
  const [updateStatusOtherReason, setUpdateStatusOtherReason] = useState('');

  let filteredStatusReasons = feeStatusReasons?.filter(option => option.additionalField.toLowerCase() === updateStatusId || option.additionalField.toLowerCase() === '00000000-0000-0000-0000-000000000000') || [];

  return (
    <ThemeProvider theme={theme}>
        <Dialog open={open} fullWidth={false} maxWidth={'lg'}>
            <Box sx={{ p: '32px' }}>
            <Typography variant="h6" sx={{ mb: '20px' }}>Change Status of Selected Records?</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '20px', mb: '20px', marginTop: '10px' }}>
              <Box>
                <Typography>Fee Status:</Typography>
                <TextField
                    select
                    
                    // className={classes.textField}
                    value={updateStatusId}
                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '110px' }}
                    onChange={e => {setUpdateStatusId(e.target.value); filteredStatusReasons = (feeStatusReasons || []).filter(option => option.additionalField.toLowerCase() === e.target.value.toLowerCase() || option.additionalField.toLowerCase() === '00000000-0000-0000-0000-000000000000');}}
                    SelectProps={{ autoWidth: true }}
                    variant="outlined"
                  >
                    {feeStatuses.map(option => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
                { (updateStatusId === 'a8aa34cf-06e0-431b-8411-45fca666fbfd' || updateStatusId === 'ceda815f-8eb7-47c2-8a38-9bd684e1b574') && (
                <Box >
                  <Typography>Status Reason:</Typography>
                  <Select
                      select
                      
                      // className={classes.textField}
                      value={updateStatusReasonId}
                      onChange={e => {setUpdateStatusReasonId(e.target.value)}}
                      // SelectProps={{ autoWidth: true }}
                      variant="outlined"
                      sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '300px' }}
                    >
                      {filteredStatusReasons.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.title}
                        </MenuItem>
                      ))}
                    </Select>
                </Box>
              )}
              { (updateStatusReasonId === '22411a19-ee33-4cd7-90d3-bc36d461a73c') && (
                <Box >
                  <Typography>Other Reason:</Typography>
                  <TextField
                      text
                      
                      // className={classes.textField}
                      value={updateStatusOtherReason}
                      sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '300px' }}
                      onChange={e => {setUpdateStatusOtherReason(e.target.value)}}
                      SelectProps={{ autoWidth: true }}
                      variant="outlined"
                      xs={{ minWidth: '200px' }}
                    >
                    </TextField>
                </Box>
              )}
            </Box>
            <Paper sx={{ mb: '20px' }}>
                <Grid rows={selectedRows} columns={columns}>
                  <SortingState sorting={sorting} onSortingChange={changeSorting} />
                  <FilteringState filters={filters} onFiltersChange={changeFilters} />
                  <IntegratedFiltering columnExtensions={integratedFilteringColumnExtensions} />
                  <IntegratedSorting />
                  <Table
                    columnExtensions={tableColumnExtensions}
                    rowComponent={rowComponent}
                    tableComponent={tableComponent}
                    cellComponent={cellComponent}
                    noDataCellComponent={noDataCellComponent}
                  />
                  <TableHeaderRow rowComponent={headerRowComponent} cellComponent={headerCell} showSortingControls />
                  <TableFilterRow cellComponent={filterCell} />
                </Grid>
              </Paper>
            
            <div className={classes.buttonContainer} >
             
              <Button variant="contained" color="secondary" onClick={onCancel} sx={{ marginRight: '10px',  }}>
                Cancel
              </Button>
               <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  onSave(updateStatusId, updateStatusReasonId, updateStatusOtherReason);
                }}
                sx={{ marginRight: '10px', }}
              >
                Save
              </Button>
            </div>
            </Box>
        </Dialog>
    </ThemeProvider>
  );
};

const mapStateToProps = state => {
//   const { countries, provinces, addressTypes, clientStatusTypes, industries } = state.enumerations.allEnums;
  
//   return {
//     countriesEnum: countries,
//     provincesEnum: provinces,
//     addressTypes: addressTypes,
//     clientStatusTypes: clientStatusTypes,
//     industries: industries
//   };
};

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    showToast,
  }),
)(ChangeFeeStatusDialog);
